// Variables globales.
var _idleTime = 0;
var _currentMiniNavBar = sessionStorage.getItem("miniNavBar");
var notifyTimer = null;
var _identityNews = getCookie("inews");
// Null on Inactived page to avoid stealing active status from other windows
var windowIdentification = window.location.pathname.toLowerCase().indexOf('/account/inactived') !== -1
    ? null
    : (Date.now() + "");

//Prevent multiple tabs with multiple context
if (windowIdentification) {
    localStorage.setItem('activeWindow', windowIdentification);
}

$(window).on("focus", function (event) {
    if (windowIdentification && localStorage.getItem('activeWindow') != windowIdentification) {
        console.log("Another active window, inactivate current window");
        event.preventDefault();
        window.location.replace("/Account/Inactived");
    }
});

$(window).on("focusout", function (event) {
    if (windowIdentification && localStorage.getItem('activeWindow') != windowIdentification) {
        console.log("Another active window, inactivate current window");
        event.preventDefault();
        window.location.replace("/Account/Inactived");
    }
});

// Gestion de la minimalisation de la barre de menu.
if (_currentMiniNavBar === null || _currentMiniNavBar === "true") {
    $("body").addClass("mini-navbar");
} else {
    $("body").removeClass("mini-navbar");
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

// Défintion du temps d'inactivité.
function SetCurrentIdleTimer() {
    if (_idleTime > 0) {
        $.idleTimer(_idleTime);
    } else {
        $.ajax({
            url: "/Account/GetCurrentIdleTimer",
            type: "POST",
            contentType: "application/json",
            success: function (receivedData) {
                _idleTime = parseInt(receivedData.result);
                $.idleTimer(_idleTime);
            }
        });
    }
}

function GetNotification() {
    var message = '';
    $.get("/Home/GetMessage", function (notification) {
        if (notification !== null) {
            toastr.options = {
                closeButton: true,
                debug: false,
                progressBar: true,
                positionClass: "toast-bottom-right",
                onclick: null,
                showDuration: 400,
                hideDuration: 1000,
                timeOut: 7000,
                extendedTimeOut: 1000,
                showEasing: "swing",
                hideEasing: "linear",
                showMethod: "fadeIn",
                hideMethod: "fadeOut"
            };
            toastr[notification.type](notification.message, notification.titre);
        }
    }).fail(function () {
        clearInterval(notifyTimer);
    });
}

function SetTreeNodeColor(tree) {
    $(tree).find('li.jstree-node').each(function (index) {
        color = $(this).attr('data-color');
        if (color !== undefined && color !== 'default') {
            $(this).children('a').children('i').css('color', color);
        }
    });
}

$("#optionsRadios1").click(function () {
    $("#userToSearch").prop("disabled", true);
    $("#reqToSearch").prop("disabled", true);
});
$("#optionsRadios2").click(function () {
    $("#userToSearch").prop("disabled", false);
    $("#reqToSearch").prop("disabled", true);
});
$("#optionsRadios3").click(function () {
    $("#userToSearch").prop("disabled", true);
    $("#reqToSearch").prop("disabled", false);
});


$(document).ready(function () {

    // Gestion des langues.
    i18next
        .use(i18nextXHRBackend)
        .init({
            lng: getCookie('i18next'),
            useOptionsAttr: true,
            debug: true,
            fallbackLng: 'fr',
            resGetPath: "../locales/__lng__/__ns__.json",
            ns: ['translation', 'agro', 'aqua', 'client'],
            defaultNS: 'translation',
            fallbackNS: 'translation'
        }, function (err, t) {
            jqueryI18next.init(i18next, $, i18next.options);
            $('html').localize();
        });

    //Gestion des news importantes
    if ($('#PopupNews div.modal-body').children().length > 0 && _identityNews !== undefined && !sessionStorage.getItem('inews_' + _identityNews)) {
        sessionStorage.setItem('inews_' + _identityNews, true);
        $('#PopupNews').modal('show');
    }

    // Gestion de la minimalisation de la barre de menu.
    $("#miniNavBarButton").on("click", function () {
        var miniNavBar = false;

        if ($("body").hasClass("mini-navbar")) {
            miniNavBar = true;
        } else {
            miniNavBar = false;
        }

        sessionStorage.setItem("miniNavBar", miniNavBar);
    });

    // Défintion du temps d'inactivité.
    SetCurrentIdleTimer();

    setTimeout(GetNotification, 1000); // Affichage de la première notification après 1"
    notifyTimer = setInterval(GetNotification, 30000); // Contrôle s'il y a de nouvelles notifications toutes les 30"

    var listeReqs = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        remote: {
            url: '/requerant/SearchRequerants#%QUERY',
            wildcard: '%QUERY',
            transport: function (opts, onSuccess, onError) {
                var url = opts.url.split("#")[0];
                var query = opts.url.split("#")[1];
                $.ajax({
                    url: url,
                    data: "texte=" + query,
                    type: "GET",
                    success: onSuccess,
                    error: onError
                })
            },
        }
    });
    let options = {
        classNames: {
            menu: 'dropdown-menu',
            suggestion: 'dropdown-item',
            open: 'w-auto',
        }
    }
    $('#requerantsToSearch').typeahead(options, {
        name: 'requerants',
        display: 'nom',
        minLength: 3,
        limit: 15,
        source: listeReqs,
        templates: {
            suggestion: function (data) {
                return '<li class="name">' + data.nom + ' ' + data.prenom + ' ' + data.npa + ' ' + data.domicile + ' (' + data.etabl + ')</li>';
            }
        }
    }).bind('typeahead:selected', function (evt, item) {
        if ($(evt.currentTarget).data('value-destination'))
            $('#' + $(evt.currentTarget).data('value-destination')).val(item.rid);
        $(this).closest('form').submit();
    })
});

// Appel de la page de logout.
$(document).on("idle.idleTimer", function (event, elem, obj) {
    console.log("Client timed out, redirecting to logout")
    window.location.replace("/Account/Logout");
});

// Jquery Cleave
(function ($, window, undefined) {
    'use strict'

    $.fn.cleave = function (opts) {

        var defaults = {autoUnmask: false},
            options = $.extend(defaults, opts || {});

        return this.each(function () {

            var cleave = new Cleave('#' + this.id, options), $this = $(this);

            $this.data('cleave-auto-unmask', options['autoUnmask']);
            ;
            $this.data('cleave', cleave)
        });
    }

    var origGetHook, origSetHook;

    if ($.valHooks.input) {

        origGetHook = $.valHooks.input.get;
        origSetHook = $.valHooks.input.set;

    } else {

        $.valHooks.input = {};
    }

    $.valHooks.input.get = function (el) {

        var $el = $(el), cleave = $el.data('cleave');

        if (cleave) {

            return $el.data('cleave-auto-unmask') ? cleave.getRawValue() : el.value;

        } else if (origGetHook) {

            return origGetHook(el);

        } else {

            return undefined;
        }
    }

    $.valHooks.input.set = function (el, val) {

        var $el = $(el), cleave = $el.data('cleave');

        if (cleave) {

            cleave.setRawValue(val);
            return $el;

        } else if (origSetHook) {

            return origSetHook(el);

        } else {
            return undefined;
        }
    }
})(jQuery, window);

// Tempus dominus global default configs
const TempusDominusDefaultConfig = {
    useCurrent: true,
    display: {
        viewMode: 'calendar',
        theme: 'light',
        icons: {
            type: 'icons',
            time: 'fas fa-clock',
            date: 'fas fa-calendar',
            up: 'fas fa-arrow-up',
            down: 'fas fa-arrow-down',
            previous: 'fas fa-chevron-left',
            next: 'fas fa-chevron-right',
            today: 'fas fa-calendar-check',
            clear: 'fas fa-trash',
            close: 'fas fa-xmark'
        },
        buttons: {
            today: true,
            clear: false,
            close: false
        },
        components: {
            calendar: true,
            date: true,
            month: true,
            year: true,
            decades: false,
            clock: false,
            hours: false,
            minutes: false,
            seconds: false,
        },
    },
    localization: {
        locale: i18next.options.lng,
        format: "dd.MM.yyyy",
        hourCycle: "h23",
        startOfTheWeek: 1,
    },
};
const TempusDominusDateTimeConfig = {
    useCurrent: true,
    display: {
        viewMode: 'calendar',
        theme: 'light',
        sideBySide: true,
        icons: {
            type: 'icons',
            time: 'fas fa-clock',
            date: 'fas fa-calendar',
            up: 'fas fa-arrow-up',
            down: 'fas fa-arrow-down',
            previous: 'fas fa-chevron-left',
            next: 'fas fa-chevron-right',
            today: 'fas fa-calendar-check',
            clear: 'fas fa-trash',
            close: 'fas fa-xmark'
        },
        buttons: {
            today: true,
            clear: false,
            close: false
        },
        components: {
            calendar: true,
            date: true,
            month: true,
            year: true,
            decades: false,
            clock: true,
            hours: true,
            minutes: true,
            seconds: false,
        },
    },
    localization: {
        locale: i18next.options.lng,
        format: "dd.MM.yyyy HH:mm",
        hourCycle: "h23",
        startOfTheWeek: 1,
    },
}

// i18next init global
i18next.on('initialized', function (options) {
    TempusDominusDefaultConfig.localization.locale = i18next.options.lng;
    TempusDominusDateTimeConfig.localization.locale = i18next.options.lng;
})

// Handle for card-collapse containing multiple targets
$(document).on("click", ".card.card-collapse .collapse-button", function (event) {
    let target = $(this).data('bs-target');
    if (target === undefined) return

    let parent = $(target).parent(".card.card-collapse");
    let header = $(parent).find('.card-header');
    if ($(header).hasClass("collapsed")) {
        $(header).removeClass("collapsed");
        $(target).collapse('show');
    } else {
        $(header).addClass("collapsed");
        $(target).collapse('hide');
    }
})
